// moms-harness:anchor v2
// JIRA: LOGISPRD-13286
/**
 * 단가 입력값 → `number | null`. **두 입력 경로(셀 편집·엑셀 업로드)가 같은 규약을 쓴다.**
 *
 * ### 숫자가 아니면 `0` 이 아니라 `null` 이다
 *
 * `0` 으로 떨어뜨리면 **0원 단가가 조용히 등록된다.** `null` 로 두면 저장 전 검증(`validateRow`)이
 * 「숫자가 아닙니다」로 잡아 사용자가 고친다.
 *
 * ### 왜 경계에서 변환하는가
 *
 * `SkuAttributeRow.receivable_price` 는 `number | null` 인데, 그리드 셀 편집은 값을 **문자열**로
 * 준다. 변환 없이 행에 쓰면 타입과 런타임이 어긋나고, `validateRow` 의 `Number.isFinite('12900')`
 * 이 **`false`** 라 정상 입력이 저장에서 막힌다(초판이 그 상태였다).
 */
export const toPriceOrNull = (value: unknown): number | null => {
  if (value == null) return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null

  const text = String(value).trim()
  if (!text) return null
  // 천단위 콤마는 사람이 넣는 표기다 — 엑셀·셀 편집 양쪽에서 들어온다
  const n = Number(text.replace(/,/g, ''))
  return Number.isFinite(n) ? n : null
}
